import React from "react";
import { TableRow, TableCell, TableSortLabel } from "@mui/material";

function UsersTableHead({ columns, order, orderBy, onSortRequest }) {
  return (
    <TableRow>
      {columns.map((column) => (
        <TableCell key={column.id} sortDirection={orderBy === column.id ? order : false}>
          {column.sortable ? (
            <TableSortLabel active={orderBy === column.id} direction={order} onClick={() => onSortRequest(column.id)}>
              {column.label}
            </TableSortLabel>
          ) : (
            column.label
          )}
        </TableCell>
      ))}
    </TableRow>
  );
}

export default UsersTableHead;